module.exports = __webpack_public_path__ + "static/media/Rectangle 58.4ffef395.png";